
import { defineComponent } from 'vue';
import logo from '@/assets/img/Logo_JL.png';

export default defineComponent({
	data() {
		return { logoSrc: logo };
	}
});
